import { forEach, get, last, split } from 'lodash'

export const getFileName = file => {
  const fileObjectStoreKey = get(file, 'objectStoreKey')
  const fileUrl = get(file, 'fileUrl')

  if (fileObjectStoreKey) {
    return last(split(fileObjectStoreKey, '/'))
  } else if (fileUrl) {
    return decodeURI(last(split(fileUrl, '/')))
  }

  return 'N/A'
}

export const formatFileName = name => name.replace(/[^a-zA-Z0-9 !\-_,.*'()]+/g, '_')

export const processFilesToUpload = files => {
  const fileNames = []
  const fileMap = {}
  let unknownCount = 1

  forEach(files, file => {
    const name = String(get(file, 'name')) || `Unknown File ${unknownCount++}`
    const formattedName = formatFileName(name)

    if (!fileNames.includes(formattedName)) {
      fileNames.push(formattedName)
      fileMap[formattedName] = file
    }
  })

  return {
    fileNames,
    fileMap,
  }
}
